module.exports = __webpack_public_path__ + "img/Cotten.66c49474.jpg";